module.exports = __webpack_public_path__ + "img/blog.0f6950c8.svg";